/**
 * Picks v2 or v1 of the Quotes page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import QuotesPage   from './QuotesPage';
import QuotesPageV2 from './QuotesPageV2';

export default function QuotesPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? QuotesPageV2 : QuotesPage;
  return <Component {...props} />;
}
